const clickButton = (buttons, callback) => {
  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", function (event) {
      event.preventDefault();
      callback(buttons[i], i);
    });
  }
};

module.exports = { clickButton };
